import { useMemo } from 'react';

import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { type ThemeName, ThemeNameEnum } from 'typedefs/themeTypes';

const themeNameAtom = atomWithStorage<ThemeName>('themeV2', ThemeNameEnum.V2, sessionStorage as any);

export const useSwitchTheme = () => {
  const [themeName, setThemeName] = useAtom(themeNameAtom);

  return useMemo(
    () => ({
      themeName,
      setThemeName,
    }),
    [setThemeName, themeName],
  );
};
